import React from 'react';
import { pricingContent } from '../data/mock';
import { Button } from './ui/button';
import { Check, ExternalLink } from 'lucide-react';

const PricingSection = ({ onContactClick }) => {
  return (
    <section id="pricing" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            {pricingContent.title}
          </h2>
          <p className="text-slate-600 text-lg">
            {pricingContent.subtitle}
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12">
          {pricingContent.plans.map((plan, index) => (
            <div
              key={index}
              className={`relative rounded-2xl p-8 transition-all duration-300 ${
                plan.highlighted
                  ? 'bg-gradient-to-b from-cyan-50 to-white border-2 border-cyan-500 shadow-lg shadow-cyan-500/10'
                  : 'bg-slate-50 border border-slate-200'
              }`}
            >
              {/* Popular badge */}
              {plan.highlighted && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <span className="bg-cyan-500 text-white text-xs font-semibold px-4 py-1 rounded-full">
                    追加診断はこちら
                  </span>
                </div>
              )}

              {/* Plan name */}
              <h3 className="text-slate-900 font-semibold text-xl mb-4">
                {plan.name}
              </h3>

              {/* Price */}
              <div className="mb-6">
                <span className="text-4xl font-bold text-slate-900">
                  {plan.price === '0' ? '￥' : '￥'}{plan.price}
                </span>
                <span className="text-slate-500 text-sm ml-2">
                  {plan.unit}
                </span>
              </div>

              {/* Features */}
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-cyan-500 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-600 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA Button */}
              <Button
                onClick={onContactClick}
                className={`free_assessment_button w-full py-6 font-semibold transition-all ${
                  plan.highlighted
                    ? 'bg-cyan-500 hover:bg-cyan-600 text-white hover:shadow-lg hover:shadow-cyan-500/25'
                    : 'bg-slate-200 hover:bg-slate-300 text-slate-700'
                }`}
              >
                {plan.ctaText}
              </Button>
            </div>
          ))}
        </div>

        {/* Sample Report Link */}
        <div className="text-center mb-8">
          <a
            href={pricingContent.sampleReportUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="sample_report__button inline-flex items-center gap-2 text-cyan-600 hover:text-cyan-700 transition-colors font-medium"
          >
            <ExternalLink className="w-4 h-4" />
            サンプルレポートを見る
          </a>
        </div>

        {/* Additional note */}
        <div className="text-center">
          <p className="text-slate-500 text-sm">
            ※ 料金は税抜表示です。別途消費税がかかります。
          </p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;